// Global constants
export const TOGGLE_SHOW_EDIT_SELECTION =
  "showComponents/TOGGLE_SHOW_EDIT_SELECTION";
export const TOGGLE_SHOW_JUMP_TO_PICK_NR =
  "showComponents/TOGGLE_SHOW_JUMP_TO_PICK_NR";
export const TOGGLE_SHOW_EDIT_DRIVES = "showComponents/TOGGLE_SHOW_EDIT_DRIVES";
export const TOGGLE_SHOW_EDIT_PICKS = "showComponents/TOGGLE_SHOW_EDIT_PICKS";
export const TOGGLE_SHOW_INFO = "showComponents/TOGGLE_SHOW_INFO";

// Local constants
export const TOGGLE_VISIBILITY_EDIT_SELECTION =
  "TOGGLE_VISIBILITY_EDIT_SELECTION";
export const TOGGLE_VISIBILITY_JUMP_TO_PICK_NR =
  "TOGGLE_VISIBILITY_JUMP_TO_PICK_NR";
export const TOGGLE_VISIBILITY_EDIT_DRIVES = "TOGGLE_VISIBILITY_EDIT_DRIVES";
export const TOGGLE_VISIBILITY_EDIT_PICKS = "TOGGLE_VISIBILITY_EDIT_PICKS";
export const TOGGLE_VISIBILITY_INFO = "TOGGLE_VISIBILITY_INFO";
